export default __webpack_public_path__ + "16edfd39513ea734de1ace3367a79bed.png";